import { CascadiaButtonGroupProps } from "./types";
import { Stack } from "../../foundations/grid-layout/Stack";

export function ButtonGroup(props: CascadiaButtonGroupProps) {
  return <Stack gap="space-2" orientation="horizontal" {...props} />;
}
